<template>
    <div v-if="showInstallments">
        <div
            :class="$x['installment-selector']"
        >
            <div style="display: flex; flex-direction: row; align-items: center; accent-color: #7123d9;">
                <div>
                    <input
                        type="checkbox"
                        id="installmentCbx"
                        style="display: block; height: 20px; width: 20px; margin-right: 10px"
                        v-model="useInstallments"
                    />
                </div>
                <div style="font-size: 16px;">{{ label }}</div>
            </div>
            <div>
                <ns-select
                    :class="$x['select']"
                    :disabled="!useInstallments"
                    v-model="selectedInstallment"
                    :items="installmentOptions"
                    name="installmentSelect"
                    height="500"
                ></ns-select>
            </div>
        </div>
        <div v-if="!!installmentMessage" :class="$x['installment-message']">
            {{installmentMessage}}
        </div>
    </div>
</template>

<script>
import {NsSelect} from "@nuskin/design-components";
import {OrderManager} from "@nuskin/ns-shop";
import {events} from "@nuskin/ns-util";
import {getCachedConfigField} from "@nuskin/configuration-sdk";

export default {
    name: "NsInstallment",
    components: {NsSelect},
    props: {
        value: {
            type: Number,
            default: null
        },
        paymentId: {
            type: Number,
            default: 1
        },
        payments: {
            type: Array,
            default() {
                return [];
            }
        },
        paymentTypes: {
            type: Array,
            default() {
                return [];
            }
        },
        label: String,
        installmentMessage: String,
    },
    data() {
        return {
            installmentCheckboxDisabled: false,
            installmentsAllowed: false,
            installmentsOnly: false,
            installmentOptions: [],
            configEnabled: getCachedConfigField('enableInstallments'),
            order: null,
            paymentType: null,
            selectedInstallment: null,
            showInstallments: false,
            useInstallments: false
        };
    },
    watch: {
        paymentId(newValue) {
            if (newValue) {
                this.paymentType = null;
                this.checkPaymentInstallments();
            }
        },
        selectedInstallment(newValue) {
            const pmt = this.payments.find(pmt => pmt.bePaymentTypeId === this.paymentId);
            if (pmt) {
                pmt.installmentSelectedNumber = parseInt(newValue);
                pmt.useInstallments = this.useInstallments;
            }
            this.$emit('input', newValue === '-' ? null : parseInt(newValue));
        },
        useInstallments() {
            this.setInstallmentOptions();
        }
    },
    methods: {
        checkPaymentInstallments() {
            if (this.configEnabled && this.paymentId && this.order && !this.order.adr) {
                const pmt = this.payments.find(pmt => pmt.bePaymentTypeId === this.paymentId);

                this.paymentType = pmt ? this.paymentTypes.find(pt => pt.id === pmt.paymentTypeId) : null;
                this.showInstallments = this.paymentType ?
                    this.paymentType.installmentsAllowed &&
                        this.paymentType.installmentNumbers &&
                        this.paymentType.installmentNumbers.length > 0 :
                    false;

                if (this.showInstallments && this.paymentType.minimumInstallmentAmount > 0) {
                    this.showInstallments = this.order.orderTotals &&
                        this.order.orderTotals.grandTotal >= this.paymentType.minimumInstallmentAmount;
                }

                if (this.showInstallments) {
                    this.setInstallmentOptions();
                    if (this.installmentOptions.includes(String(this.value))) {
                        this.selectedInstallment = String(this.value);
                        this.useInstallments = true;
                    }
                }
            }
        },

        setInstallmentOptions() {
            if (this.paymentType) {
                this.installmentOptions = [];
                if (!this.useInstallments) {
                    this.installmentOptions.push('-');
                }
                this.paymentType.installmentNumbers.forEach(installment => this.installmentOptions.push(String(installment)));
                if (!this.useInstallments ||
                    !this.selectedInstallment ||
                    !this.installmentOptions.includes(String(this.selectedInstallment))) {
                    this.selectedInstallment = this.installmentOptions[0];
                }
            }
        },
    },

    mounted() {
        let scope = this;
        events.subscribe(events.shop.ORDER_UPDATED, (orders) => {
            scope.order = orders.find(order => !order.completed);
            scope.checkPaymentInstallments();
        });

        this.order = OrderManager.getOrder();
        this.checkPaymentInstallments();
    }
};
</script>
<style lang="scss" module="$x">
@use "./installment.module.scss";
//TODO a temp fix for a weird issue. removing it start throwing error while unit test.
.dummy {
  color: blue;
}
</style>
